import R from 'ramda'
import {
  mapTwitterFormTriggersToWidgetTriggers,
  mapTwitterWidgetTriggersToFormTriggers
} from './twitter'
import {
  mapInstagramFormTriggersToWidgetTriggers,
  mapInstagramWidgetTriggersToFormTriggers
} from './instagram'
import {
  mapFacebookFormTriggersToWidgetTriggers,
  mapFacebookWidgetTriggersToFormTriggers
} from './facebook'

const PLATFORM_TWITTER = 'TWITTER'
const PLATFORM_INSTAGRAM = 'INSTAGRAM'
const PLATFORM_FACEBOOK = 'FACEBOOK'

const getPlatform = R.pipe(R.propOr(PLATFORM_TWITTER, 'platform'), R.toUpper)

const isTwitter = R.pipe(getPlatform, R.equals(PLATFORM_TWITTER))
const isInstagram = R.pipe(getPlatform, R.equals(PLATFORM_INSTAGRAM))
const isFacebook = R.pipe(getPlatform, R.equals(PLATFORM_FACEBOOK))

const getTriggers = R.prop('triggers')

const mapFormTriggersToWidgetTriggers = R.cond([
  [isTwitter, R.pipe(getTriggers, mapTwitterFormTriggersToWidgetTriggers)],
  [isInstagram, R.pipe(getTriggers, mapInstagramFormTriggersToWidgetTriggers)],
  [isFacebook, R.pipe(getTriggers, mapFacebookFormTriggersToWidgetTriggers)],
  [R.T, R.pipe(getTriggers, mapTwitterFormTriggersToWidgetTriggers)]
])

const mapWidgetTriggersToFormTriggers = R.cond([
  [isTwitter, R.pipe(getTriggers, mapTwitterWidgetTriggersToFormTriggers)],
  [isInstagram, R.pipe(getTriggers, mapInstagramWidgetTriggersToFormTriggers)],
  [isFacebook, R.pipe(getTriggers, mapFacebookWidgetTriggersToFormTriggers)],
  [R.T, R.pipe(getTriggers, mapTwitterWidgetTriggersToFormTriggers)]
])

export { mapFormTriggersToWidgetTriggers, mapWidgetTriggersToFormTriggers }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/index.js